<!-- Points Summary -->
<div class="full-page-container">
  <div class="container px-0">
    <fgb-points-summary-bar [marketplaceItemGroup]="marketplaceItemType.group"></fgb-points-summary-bar>

    <div
      class="back-btn bg-glass-dark text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
      (click)="goBack()"
    >
      <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
    </div>
  </div>

  <fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
</div>
